/** Seller = counterparty on the Sell leg; Buyer = counterparty on the Buy leg. */
export function resolveBuybackSellerBuyer(tx) {
  const leg1Name = tx.leg1_counterparty_name || tx.leg1_counterparty || '';
  const leg2Name = tx.leg2_counterparty_name || tx.leg2_counterparty || '';
  const leg1Type = String(tx.leg1_transaction_type || '').toLowerCase();
  const leg2Type = String(tx.leg2_transaction_type || '').toLowerCase();

  if (leg1Type === 'sell' || leg2Type === 'buy') {
    return { seller: leg1Name, buyer: leg2Name };
  }
  if (leg1Type === 'buy' || leg2Type === 'sell') {
    return { seller: leg2Name, buyer: leg1Name };
  }
  return { seller: leg1Name, buyer: leg2Name };
}

/** Only Buy/Sell buybacks carry leg 1 / leg 2 settlement instruction letters. */
export function isBuySellBuyback(tx) {
  return (
    String(tx.leg1_transaction_type || '').toLowerCase() === 'buy' &&
    String(tx.leg2_transaction_type || '').toLowerCase() === 'sell'
  );
}
